import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { Communication } from './communication.interface';
import { BulkWhatsappMessage } from './whatsapp/whatsapp.interface';

class COMMUNICATION_INCLUDES_CLASS {
   activity: Record<'includes' | 'appends', Array<string>> = {
      includes: ['communication_type', 'communication_direction_type', 'receivable', 'sendable', 'type'],
      appends: [],
   };
}

export const COMMUNICATION_INCLUDES = new COMMUNICATION_INCLUDES_CLASS();

export class CommunicationService {
   async postCommunication(communication: Communication) {
      const response = await http.post<ApiResource<Communication>>(`/communications`, communication);
      return response.data;
   }
   async patchCommunication(communicationId: number, communication: { [key: string]: any }) {
      const response = await http.patch<ApiResource<Communication>>(`/communications/${communicationId}`, communication);
      return response.data;
   }
   async sendSms(communication: BulkWhatsappMessage) {
      const formData = new FormData();
      if (communication.original_recipient) {
         formData.append('original_recipient', communication.original_recipient);
      } else {
         formData.append('receiver_type', communication.receiver_type);
         communication.receiver_ids?.forEach((id) => {
            formData.append('receiver_ids[]', id.toString());
         });
      }
      // formData.append('message', communication.message || '');
      Object.keys(communication.message || {}).forEach((key) => {
         formData.append(`message[${key}]`, communication.message?.[key] || '');
      });

      if (communication.template_id) formData.append('template_id', communication.template_id?.toString());
      if (communication.position_id) formData.append('position_id', communication.position_id?.toString());
      if (communication.customer_id) formData.append('customer_id', communication.customer_id?.toString());
      if (communication.attachments) formData.append('attachment', communication.attachments);
      if (communication.journey_id) formData.append('journey_id', communication.journey_id?.toString());
      if (communication.journey_team_id) formData.append('journey_team_id', communication.journey_team_id?.toString());
      if (communication.variables) {
         Object.keys(communication.variables).forEach((key) => {
            formData.append(`variables[${key}]`, communication.variables?.[key] || '');
         });
      }
      formData.append('batch', communication.batch.toString());

      const response = await http.post<ApiResource<Communication>>(`/communications/sms/send`, formData);
      return response.data;
   }
   async sendWhatsapp(communication: BulkWhatsappMessage) {
      const formData = new FormData();
      if (communication.original_recipient) {
         formData.append('original_recipient', communication.original_recipient);
      } else {
         formData.append('receiver_type', communication.receiver_type);
         communication.receiver_ids?.forEach((id) => {
            formData.append('receiver_ids[]', id.toString());
         });
      }
      // formData.append('message', communication.message || '');

      formData.append(`message`, communication.message || '');

      if (communication.template_id) formData.append('template_id', communication.template_id?.toString());
      if (communication.position_id) formData.append('position_id', communication.position_id?.toString());
      if (communication.customer_id) formData.append('customer_id', communication.customer_id?.toString());
      if (communication.attachments) formData.append('attachment', communication.attachments);
      if (communication.journey_id) formData.append('journey_id', communication.journey_id?.toString());
      if (communication.journey_team_id) formData.append('journey_team_id', communication.journey_team_id?.toString());
      if (communication.variables) {
         Object.keys(communication.variables).forEach((key) => {
            formData.append(`variables[${key}]`, communication.variables?.[key] || '');
         });
      }
      formData.append('batch', communication.batch);

      const response = await http.post<ApiResource<Communication>>(`/communications/whatsapp/send`, formData);
      return response.data;
   }
}
